import React, { Component } from "react";
 
class Footer extends Component {
  render() {
    return (
      <footer className="text-muted">
          <div className="container">
              <p>New to Bootstrap? <a href="https://getbootstrap.com/">Visit the homepage</a> or read our <a href="/docs/4.3/getting-started/introduction/">getting started guide</a>.</p>
          </div>
      </footer>
    );
  }
}

export default Footer;